// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"02e34164","796":"2d1da4ec"}[chunkId] + ".chunk.js";
};